import { Card } from "@hdi-seguros/web-components.card";
import { Row, Typography } from "antd";
import { FC } from "react";
import { _renderColumns } from "../CardRenderWithButton/renderSections";
import { PolicyStates } from "../../interfaces";

interface CardRenderProps {
    title: string;
    article?: string | undefined;
    tags?: PolicyStates[] | undefined;
    actions?: any;
    loading: boolean | undefined;
    columnsData: Array<any>;
}

const _renderTitle = (title: string) => (
    <>
      <Typography.Text strong style={{ margin: 0, marginRight: 10 }}>
        {' '}
        {title}
      </Typography.Text>
    </>
);

export const CardRender: FC<CardRenderProps> = ({title, article, tags, actions, loading, columnsData}) => {
    return (
      <Card
        title={_renderTitle(title)}
        tags={tags as any}
        actions={actions}
        loading={loading}
        style={{
          marginBottom: 20,
          width: '100%',
        }}
      >
        <Row style={{ marginLeft: 0 }} gutter={[10, 10]}>
          {_renderColumns(columnsData)}
        </Row>
      </Card>
    )
}